export const generateCareerPathHTML = (sheetUrl = '') => {
  return `<!DOCTYPE html>
<html lang="ko">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>AI Career Pathfinder - AI 맞춤 진로 경로</title>
    <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            min-height: 100vh;
            color: #333;
        }
        
        .min-h-screen {
            min-height: 100vh;
        }
        
        .bg-gradient-to-b {
            background: linear-gradient(to bottom, #9333ea, #7c3aed, #c026d3);
        }
        
        .text-white {
            color: white;
        }
        
        .sticky {
            position: sticky;
        }
        
        .top-0 {
            top: 0;
        }
        
        .z-10 {
            z-index: 10;
        }
        
        .backdrop-blur {
            backdrop-filter: blur(10px);
        }
        
        .bg-white\\/10 {
            background-color: rgba(255, 255, 255, 0.1);
        }
        
        .border-b {
            border-bottom-width: 1px;
        }
        
        .border-white\\/20 {
            border-color: rgba(255, 255, 255, 0.2);
        }
        
        .max-w-6xl {
            max-width: 72rem;
        }
        
        .mx-auto {
            margin-left: auto;
            margin-right: auto;
        }
        
        .px-4 {
            padding-left: 1rem;
            padding-right: 1rem;
        }
        
        .py-3 {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }
        
        .py-6 {
            padding-top: 1.5rem;
            padding-bottom: 1.5rem;
        }
        
        .flex {
            display: flex;
        }
        
        .items-center {
            align-items: center;
        }
        
        .justify-between {
            justify-content: space-between;
        }
        
        .justify-center {
            justify-content: center;
        }
        
        .text-2xl {
            font-size: 1.5rem;
            line-height: 2rem;
        }
        
        .text-xl {
            font-size: 1.25rem;
            line-height: 1.75rem;
        }
        
        .text-xs {
            font-size: 0.75rem;
            line-height: 1rem;
        }
        
        .text-sm {
            font-size: 0.875rem;
            line-height: 1.25rem;
        }
        
        .font-bold {
            font-weight: 700;
        }
        
        .font-semibold {
            font-weight: 600;
        }
        
        .font-medium {
            font-weight: 500;
        }
        
        .text-white\\/80 {
            color: rgba(255, 255, 255, 0.8);
        }
        
        .space-y-6 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 1.5rem;
        }
        
        .space-y-4 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 1rem;
        }
        
        .space-y-3 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 0.75rem;
        }
        
        .space-y-2 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 0.5rem;
        }
        
        .space-y-1 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 0.25rem;
        }
        
        .grid {
            display: grid;
        }
        
        .md\\:grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        
        .md\\:grid-cols-3 {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        
        .sm\\:grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        
        .grid-cols-2 {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        
        .grid-cols-1 {
            grid-template-columns: repeat(1, minmax(0, 1fr));
        }
        
        .gap-4 {
            gap: 1rem;
        }
        
        .gap-3 {
            gap: 0.75rem;
        }
        
        .gap-2 {
            gap: 0.5rem;
        }
        
        .bg-white\\/95 {
            background-color: rgba(255, 255, 255, 0.95);
        }
        
        .bg-white\\/90 {
            background-color: rgba(255, 255, 255, 0.9);
        }
        
        .bg-white\\/20 {
            background-color: rgba(255, 255, 255, 0.2);
        }
        
        .rounded-2xl {
            border-radius: 1rem;
        }
        
        .rounded-xl {
            border-radius: 0.75rem;
        }
        
        .rounded-lg {
            border-radius: 0.5rem;
        }
        
        .rounded-full {
            border-radius: 9999px;
        }
        
        .p-5 {
            padding: 1.25rem;
        }
        
        .p-4 {
            padding: 1rem;
        }
        
        .p-3 {
            padding: 0.75rem;
        }
        
        .p-2 {
            padding: 0.5rem;
        }
        
        .p-1 {
            padding: 0.25rem;
        }
        
        .px-4 {
            padding-left: 1rem;
            padding-right: 1rem;
        }
        
        .px-3 {
            padding-left: 0.75rem;
            padding-right: 0.75rem;
        }
        
        .py-2 {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }
        
        .py-1 {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
        
        .px-2 {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
        }
        
        .px-12 {
            padding-left: 3rem;
            padding-right: 3rem;
        }
        
        .py-5 {
            padding-top: 1.25rem;
            padding-bottom: 1.25rem;
        }
        
        .shadow {
            box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
        }
        
        .text-slate-900 {
            color: #0f172a;
        }
        
        .text-slate-800 {
            color: #1e293b;
        }
        
        .text-slate-600 {
            color: #475569;
        }
        
        .text-purple-700 {
            color: #7c3aed;
        }
        
        .text-purple-600 {
            color: #9333ea;
        }
        
        .block {
            display: block;
        }
        
        .mt-1 {
            margin-top: 0.25rem;
        }
        
        .mt-2 {
            margin-top: 0.5rem;
        }
        
        .mt-4 {
            margin-top: 1rem;
        }
        
        .mb-2 {
            margin-bottom: 0.5rem;
        }
        
        .mb-3 {
            margin-bottom: 0.75rem;
        }
        
        .w-full {
            width: 100%;
        }
        
        .w-32 {
            width: 8rem;
        }
        
        .h-32 {
            height: 8rem;
        }
        
        .space-y-3 > :not([hidden]) ~ :not([hidden]) {
            margin-top: 0.75rem;
        }
        
        .text-lg {
            font-size: 1.125rem;
            line-height: 1.75rem;
        }
        
        .text-6xl {
            font-size: 3.75rem;
            line-height: 1;
        }
        
        .bg-blue-50 {
            background-color: #eff6ff;
        }
        
        .border-blue-200 {
            border-color: #bfdbfe;
        }
        
        .text-blue-800 {
            color: #1e40af;
        }
        
        .text-blue-700 {
            color: #1d4ed8;
        }
        
        .bg-gray-100 {
            background-color: #f3f4f6;
        }
        
        .text-gray-600 {
            color: #4b5563;
        }
        
        .w-16 {
            width: 4rem;
        }
        
        .h-16 {
            height: 4rem;
        }
        
        .border {
            border-width: 1px;
        }
        
        .bg-purple-600 {
            background-color: #9333ea;
        }
        
        .bg-purple-700 {
            background-color: #7c3aed;
        }
        
        .bg-white {
            background-color: #fff;
        }
        
        .bg-slate-50 {
            background-color: #f8fafc;
        }
        
        .cursor-pointer {
            cursor: pointer;
        }
        
        .transition-all {
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
        }
        
        .duration-200 {
            transition-duration: 200ms;
        }
        
        .flex-wrap {
            flex-wrap: wrap;
        }
        
        .flex-1 {
            flex: 1 1 0%;
        }
        
        .items-start {
            align-items: flex-start;
        }
        
        .list-disc {
            list-style-type: disc;
        }
        
        .list-inside {
            list-style-position: inside;
        }
        
        .w-100 {
            width: 100%;
            max-width: 600px;
            height: 250px;
        }
        
        button:hover {
            opacity: 0.9;
        }
        
        .fade-in {
            animation: fadeIn 0.5s ease-in;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }
        
        select, button, input, textarea {
            font-family: inherit;
        }
        
        select {
            background: white;
            border: 1px solid #d1d5db;
            border-radius: 0.5rem;
            padding: 0.5rem;
        }
        
        .name-input-section {
            background: white;
            border-radius: 15px;
            padding: 40px;
            margin: 30px 0;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
            text-align: center;
        }
        
        .name-card h2 {
            color: #2c3e50;
            margin-bottom: 15px;
            font-size: 2em;
        }
        
        .name-card p {
            color: #7f8c8d;
            margin-bottom: 30px;
            font-size: 1.1em;
        }
        
        .name-input {
            width: 100%;
            max-width: 400px;
            padding: 15px;
            font-size: 1.2em;
            border: 2px solid #bdc3c7;
            border-radius: 10px;
            margin-bottom: 25px;
            text-align: center;
            transition: all 0.3s ease;
        }
        
        .name-input:focus {
            outline: none;
            border-color: #3498db;
            box-shadow: 0 0 10px rgba(52,152,219,0.3);
        }
        
        .btn {
            padding: 15px 30px;
            border: none;
            border-radius: 25px;
            font-size: 1.1em;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
            text-transform: uppercase;
            letter-spacing: 1px;
        }
        
        .btn-primary {
            background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
            color: white;
        }
        
        .btn-primary:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(52,152,219,0.3);
        }
        
        .btn-success {
            background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
            color: white;
        }
        
        .btn-success:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 20px rgba(39,174,96,0.3);
        }
        
        .deploy-section {
            background: white;
            border-radius: 15px;
            padding: 30px;
            margin: 30px 0;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
            text-align: center;
        }
        
        .deploy-title {
            font-size: 1.5em;
            color: #2c3e50;
            margin-bottom: 20px;
        }
        
        @media (max-width: 768px) {
            .md\\:grid-cols-2 {
                grid-template-columns: repeat(1, minmax(0, 1fr));
            }
            
            .md\\:grid-cols-3 {
                grid-template-columns: repeat(1, minmax(0, 1fr));
            }
            
            .max-w-6xl {
                max-width: 100%;
            }
            
            .text-2xl {
                font-size: 1.25rem;
            }
            
            .px-4 {
                padding-left: 0.5rem;
                padding-right: 0.5rem;
            }
        }
    </style>
</head>
<body>
    <div class="min-h-screen bg-gradient-to-b text-white" id="app">
        <header class="sticky top-0 z-10 backdrop-blur bg-white/10 border-b border-white/20">
            <div class="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
                <h1 class="text-2xl font-bold">AI Career Pathfinder</h1>
                <div class="text-xs text-white/80">VOCATIONAL ENGLISH • AI‑READY</div>
            </div>
        </header>

        <main class="max-w-6xl mx-auto px-4 py-6 space-y-6">
            <!-- 학습자 정보 입력 섹션 -->
            <div class="name-input-section" id="nameInputSection">
                <div class="name-card">
                    <h2>👋 학습자 정보 입력</h2>
                    <p>AI 맞춤 진로 경로 분석을 시작하기 전에 이름을 입력해주세요.</p>
                    <input type="text" id="studentName" placeholder="이름을 입력하세요" class="name-input">
                    <button class="btn btn-primary" onclick="startCareerAnalysis()">진로 분석 시작</button>
                    <p class="text-xs text-gray-500 mt-2">💡 이름 입력 후 Enter를 누르거나 버튼을 클릭하세요</p>
                </div>
            </div>

            <!-- Step 1 -->
            <section class="grid md:grid-cols-2 gap-4" id="step1" style="display:none;">
                <div class="bg-white/10 rounded-2xl p-5 shadow">
                    <h2 class="text-xl font-semibold">1) Your Profile</h2>
                    <div class="bg-white/95 rounded-2xl p-4 text-slate-900 space-y-4">
                        <div>
                            <label class="block text-sm font-medium">MBTI</label>
                            <select class="mt-1 w-full border rounded-lg p-2" id="mbtiSelect">
                                <option value="INTJ">INTJ</option>
                                <option value="INTP" selected>INTP</option>
                                <option value="ENTJ">ENTJ</option>
                                <option value="ENTP">ENTP</option>
                                <option value="INFJ">INFJ</option>
                                <option value="INFP">INFP</option>
                                <option value="ENFJ">ENFJ</option>
                                <option value="ENFP">ENFP</option>
                                <option value="ISTJ">ISTJ</option>
                                <option value="ISFJ">ISFJ</option>
                                <option value="ESTJ">ESTJ</option>
                                <option value="ESFJ">ESFJ</option>
                                <option value="ISTP">ISTP</option>
                                <option value="ISFP">ISFP</option>
                                <option value="ESTP">ESTP</option>
                                <option value="ESFP">ESFP</option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-sm font-medium">CEFR Level</label>
                            <div class="flex gap-2 mt-1 flex-wrap" id="cefrButtons">
                                <button onclick="setCefr('A1')" class="px-3 py-1 rounded-full border bg-white text-slate-800" data-level="A1">A1</button>
                                <button onclick="setCefr('A2')" class="px-3 py-1 rounded-full border bg-white text-slate-800" data-level="A2">A2</button>
                                <button onclick="setCefr('B1')" class="px-3 py-1 rounded-full border bg-white text-slate-800" data-level="B1">B1</button>
                                <button onclick="setCefr('B2')" class="px-3 py-1 rounded-full border bg-purple-600 text-white" data-level="B2">B2</button>
                            </div>
                        </div>
                        <div>
                            <label class="block text-sm font-medium">Activities</label>
                            <div class="grid grid-cols-2 gap-2 mt-1" id="activitiesGrid">
                                <button onclick="toggleActivity('Scratch game')" class="px-2 py-1 rounded-lg text-sm bg-white border">Scratch game</button>
                                <button onclick="toggleActivity('school science fair')" class="px-2 py-1 rounded-lg text-sm bg-white border">school science fair</button>
                                <button onclick="toggleActivity('YouTube video editing')" class="px-2 py-1 rounded-lg text-sm bg-white border">YouTube video editing</button>
                                <button onclick="toggleActivity('café part-time')" class="px-2 py-1 rounded-lg text-sm bg-white border">café part-time</button>
                                <button onclick="toggleActivity('Robotics club')" class="px-2 py-1 rounded-lg text-sm bg-white border">Robotics club</button>
                                <button onclick="toggleActivity('Art/design')" class="px-2 py-1 rounded-lg text-sm bg-purple-600 text-white">Art/design</button>
                                <button onclick="toggleActivity('Sports team')" class="px-2 py-1 rounded-lg text-sm bg-white border">Sports team</button>
                                <button onclick="toggleActivity('Volunteering')" class="px-2 py-1 rounded-lg text-sm bg-white border">Volunteering</button>
                                <button onclick="toggleActivity('Store sales')" class="px-2 py-1 rounded-lg text-sm bg-white border">Store sales</button>
                                <button onclick="toggleActivity('Blog writing')" class="px-2 py-1 rounded-lg text-sm bg-white border">Blog writing</button>
                                <button onclick="toggleActivity('Math study group')" class="px-2 py-1 rounded-lg text-sm bg-white border">Math study group</button>
                            </div>
                        </div>
                        <button class="w-full py-2 rounded-xl bg-purple-700 text-white font-semibold" onclick="generatePath()">Generate My Path ▸</button>
                    </div>
                </div>
                <div class="bg-white/10 rounded-2xl p-5 shadow">
                    <h3 class="text-xl font-semibold mb-2">Career Cluster Preview</h3>
                    <div class="w-full bg-white/90 rounded-xl p-4 text-slate-900">
                        <div class="space-y-3" id="careerBars">
                            <div class="career-bar">
                                <div class="flex justify-between items-center mb-1">
                                    <span class="text-sm font-medium">AI Engineer</span>
                                    <span class="text-xs text-gray-600" id="ai-score">9점</span>
                                </div>
                                <div class="w-full bg-gray-200 rounded-full h-3">
                                    <div class="bg-purple-600 h-3 rounded-full transition-all duration-300" id="ai-bar" style="width: 90%"></div>
                                </div>
                            </div>
                            <div class="career-bar">
                                <div class="flex justify-between items-center mb-1">
                                    <span class="text-sm font-medium">Data Scientist</span>
                                    <span class="text-xs text-gray-600" id="data-score">7점</span>
                                </div>
                                <div class="w-full bg-gray-200 rounded-full h-3">
                                    <div class="bg-green-500 h-3 rounded-full transition-all duration-300" id="data-bar" style="width: 70%"></div>
                                </div>
                            </div>
                            <div class="career-bar">
                                <div class="flex justify-between items-center mb-1">
                                    <span class="text-sm font-medium">Product Manager (Tech)</span>
                                    <span class="text-xs text-gray-600" id="pm-score">6점</span>
                                </div>
                                <div class="w-full bg-gray-200 rounded-full h-3">
                                    <div class="bg-blue-500 h-3 rounded-full transition-all duration-300" id="pm-bar" style="width: 60%"></div>
                                </div>
                            </div>
                            <div class="career-bar">
                                <div class="flex justify-between items-center mb-1">
                                    <span class="text-sm font-medium">UI Designer</span>
                                    <span class="text-xs text-gray-600" id="ui-score">7점</span>
                                </div>
                                <div class="w-full bg-gray-200 rounded-full h-3">
                                    <div class="bg-orange-500 h-3 rounded-full transition-all duration-300" id="ui-bar" style="width: 70%"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Step 2 -->
            <section class="bg-white/10 rounded-2xl p-5 shadow" id="step2" style="display:none;">
                <h2 class="text-xl font-semibold mb-3">2) Your AI‑tailored Path</h2>
                <div class="grid md:grid-cols-3 gap-4">
                    <div class="bg-white/90 text-slate-900 rounded-2xl p-4">
                        <div class="font-semibold mb-2">Recommended Paths</div>
                        <ol class="space-y-2 text-sm" id="recommendedPaths">
                            <li><span class="text-purple-700 font-bold">1.</span> AI Engineer</li>
                            <li><span class="text-purple-700 font-bold">2.</span> Data Scientist</li>
                            <li><span class="text-purple-700 font-bold">3.</span> Product Manager (Tech)</li>
                            <li><span class="text-purple-700 font-bold">4.</span> UI Designer</li>
                        </ol>
                    </div>
                    <div class="bg-white/90 text-slate-900 rounded-2xl p-4">
                        <div class="font-semibold mb-2">AI Impact Tips</div>
                        <ul class="list-disc list-inside text-sm space-y-1">
                            <li>AI Engineer: Learn prompt design and model limits</li>
                            <li>AI Engineer: Build small AI tools to solve problems</li>
                            <li>AI Engineer: Stay ethical with data</li>
                            <li>Data Scientist: Use AI for fast data cleaning</li>
                        </ul>
                    </div>
                    <div class="bg-white/90 text-slate-900 rounded-2xl p-4">
                        <div class="font-semibold mb-2">English in your Field</div>
                        <ul class="list-disc list-inside text-sm space-y-1">
                            <li>AI Engineer: Read docs and papers</li>
                            <li>AI Engineer: Write clear commit messages</li>
                            <li>AI Engineer: Explain systems to non-experts</li>
                            <li>Data Scientist: Write reports</li>
                        </ul>
                    </div>
                </div>
                <div class="mt-4 flex justify-between">
                    <button class="px-4 py-2 rounded bg-white/20" onclick="goToStep(1)">◂ Back</button>
                    <button class="px-4 py-2 rounded bg-white text-purple-700" onclick="goToStep(3)">Next ▸</button>
                </div>
            </section>

            <!-- Step 3 -->
            <div id="step3" style="display:none;">
                <section class="bg-white/10 rounded-2xl p-5 shadow">
                    <h2 class="text-xl font-semibold mb-3">Role Models Like You</h2>
                    <div class="grid sm:grid-cols-2 gap-4">
                        <div class="bg-white/90 text-slate-900 rounded-2xl p-4 flex items-start gap-3">
                            <img src="https://i.pravatar.cc/100?img=1" alt="Minho" class="w-16 h-16 rounded-full" />
                            <div>
                                <div class="font-semibold">Minho</div>
                                <div class="text-xs text-slate-600">AI Engineer • INTJ</div>
                                <div class="mt-2 text-sm bg-slate-50 border rounded-xl p-2">Hi! I'm Minho. As an AI Engineer, keep coding daily, read docs, and share your work with peers.</div>
                            </div>
                        </div>
                        <div class="bg-white/90 text-slate-900 rounded-2xl p-4 flex items-start gap-3">
                            <img src="https://i.pravatar.cc/100?img=2" alt="Dohyun" class="w-16 h-16 rounded-full" />
                            <div>
                                <div class="font-semibold">Dohyun</div>
                                <div class="text-xs text-slate-600">Product Manager (Tech) • ENTP</div>
                                <div class="mt-2 text-sm bg-slate-50 border rounded-xl p-2">Hi! I'm Dohyun. As a PM, focus on communication, teamwork, and translating tech into simple terms.</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="bg-white/10 rounded-2xl p-5 shadow space-y-3">
                    <h2 class="text-xl font-semibold mb-3">Vocational English Practice</h2>
                    <div class="bg-white/90 text-slate-900 rounded-xl p-3 text-sm">
                        <div class="font-medium mb-1">Your Prompt</div>
                        <div id="currentTask">Email your manager to request a project deadline extension.</div>
                        <button class="mt-2 px-3 py-1 rounded bg-purple-600 text-white" onclick="nextTask()">Next Task</button>
                    </div>
                    <div class="bg-white/90 text-slate-900 rounded-xl p-3 text-sm">
                        <div class="font-medium mb-1">Model Answer (CEFR <span id="cefrLevel">B2</span>)</div>
                        <div id="modelAnswer">Dear Team, I'd like to email your manager to request a project deadline extension. Please let me know a convenient time. Thanks in advance.</div>
                    </div>
                    <textarea id="studentText" class="w-full h-40 rounded-xl p-3 text-slate-900" placeholder="Write your response here…"></textarea>
                    <div id="feedbackGrid" class="grid grid-cols-2 sm:grid-cols-4 gap-3" style="display:none;">
                        <div class="p-3 bg-white/90 rounded-xl text-slate-900">
                            <div class="text-sm font-medium">Grammar</div>
                            <div class="h-2 bg-slate-200 rounded-full overflow-hidden">
                                <div class="h-full bg-blue-500" style="width: 80%"></div>
                            </div>
                            <div class="mt-1 text-xs">80%</div>
                        </div>
                        <div class="p-3 bg-white/90 rounded-xl text-slate-900">
                            <div class="text-sm font-medium">Vocabulary</div>
                            <div class="h-2 bg-slate-200 rounded-full overflow-hidden">
                                <div class="h-full bg-green-500" style="width: 100%"></div>
                            </div>
                            <div class="mt-1 text-xs">100%</div>
                        </div>
                        <div class="p-3 bg-white/90 rounded-xl text-slate-900">
                            <div class="text-sm font-medium">Clarity</div>
                            <div class="h-2 bg-slate-200 rounded-full overflow-hidden">
                                <div class="h-full bg-purple-500" style="width: 85%"></div>
                            </div>
                            <div class="mt-1 text-xs">85%</div>
                        </div>
                        <div class="p-3 bg-white/90 rounded-xl text-slate-900">
                            <div class="text-sm font-medium">Task</div>
                            <div class="h-2 bg-slate-200 rounded-full overflow-hidden">
                                <div class="h-full bg-red-500" style="width: 67%"></div>
                            </div>
                            <div class="mt-1 text-xs">67%</div>
                        </div>
                    </div>
                    <div class="mt-4 flex justify-between">
                        <button class="px-4 py-2 rounded bg-white/20" onclick="goToStep(2)">◂ Back</button>
                        <button class="px-4 py-2 rounded bg-white text-purple-700" onclick="completeAnalysis()">학습 완료</button>
                    </div>
                </section>
            </div>
        </main>

        <!-- 학습 완료 섹션 -->
        <div class="deploy-section" id="deploySection" style="display:none;">
            <div class="text-center">
                <div class="text-6xl mb-4">🎉</div>
                <h2 class="deploy-title">학습 완료!</h2>
                <p class="text-lg mb-6">AI 맞춤 진로 경로 분석이 완료되었습니다.</p>
                
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
                    <h3 class="font-semibold text-blue-800 mb-2">📋 분석 결과 요약</h3>
                    <div class="space-y-1 text-sm text-blue-700">
                        <p>• <strong>MBTI 유형:</strong> <span id="summary-mbti">INTP</span></p>
                        <p>• <strong>영어 레벨:</strong> <span id="summary-cefr">B2</span></p>
                        <p>• <strong>선택된 활동:</strong> <span id="summary-activities">Art/design</span></p>
                        <p>• <strong>완료 단계:</strong> <span id="summary-steps">3</span>/3단계</p>
                    </div>
                </div>
                
                <div class="space-y-3">
                    <button class="btn btn-primary w-full" onclick="resetQuiz()">
                        🔄 다시 분석하기
                    </button>
                    <button class="btn btn-success w-full" onclick="window.print()">
                        🖨️ 결과 인쇄하기
                    </button>
                    <button class="btn" onclick="closeWindow()" style="background-color: #6b7280; color: white; width: 100%;">
                        🚪 창 닫기
                    </button>
                </div>
                
                <div class="mt-6 p-3 bg-gray-100 rounded-lg text-xs text-gray-600">
                    <p>💡 <strong>활용 팁:</strong> 이 분석 결과를 바탕으로 관련 직업 정보를 더 찾아보거나, 해당 분야의 영어 학습 자료를 찾아 공부해보세요!</p>
                </div>
            </div>
        </div>
    </div>

    <script>
        // 전역 변수
        let currentStep = 0;
        let mbti = 'INTP';
        let cefr = 'B2';
        let selectedActivities = ['Art/design'];
        let taskIndex = 0;
        let studentName = '';
        let learningStartTime = null;
        
        const TASKS = [
            "Email your manager to request a project deadline extension.",
            "Write to a customer introducing a new product feature.",
            "Ask a professor for a recommendation letter.",
            "Invite colleagues to a weekly team sync meeting.",
            "Follow up with a client after a demo call."
        ];
        
        const CLUSTERS = ["AI Engineer", "Data Scientist", "Product Manager (Tech)", "UI Designer"];
        const ACTIVITIES = ["Scratch game", "school science fair", "YouTube video editing", "café part-time", "Robotics club", "Art/design", "Sports team", "Volunteering", "Store sales", "Blog writing", "Math study group"];
        
        // LearningLogger 클래스 정의 (임베디드)
        class LearningLogger {
            constructor(options = {}) {
                this.sheetId = options.sheetId || this.extractSheetId(options.sheetUrl);
                this.webAppUrl = options.webAppUrl || 'https://script.google.com/macros/s/AKfycbzKJqOo1dqcTlT4TSB51e3EsHH5EFm7m6zcsLMWUQWSOGXx6MDryptjhiUj04oMmA3b/exec';
                this.templateId = options.templateId || 'unknown';
                this.isEnabled = options.isEnabled !== false;
                
                this.sessionData = {
                    studentName: '',
                    sessionStartTime: null,
                    totalLearningTime: 0,
                    correctAnswers: 0,
                    wrongAnswers: 0,
                    skippedAnswers: 0,
                    hintsUsed: false,
                    additionalData: {},
                    logTime: null
                };
            }

            extractSheetId(url) {
                if (!url) return null;
                const match = url.match(/\\/spreadsheets\\/d\\/([a-zA-Z0-9-_]+)/);
                return match ? match[1] : null;
            }

            startSession(studentName, additionalData = {}) {
                this.sessionData.studentName = studentName;
                this.sessionData.sessionStartTime = new Date();
                this.sessionData.additionalData = { ...additionalData };
                console.log('📚 학습 세션 시작:', studentName);
            }

            calculateLearningTime() {
                if (!this.sessionData.sessionStartTime) return 0;
                const endTime = new Date();
                return Math.round((endTime - this.sessionData.sessionStartTime) / 1000);
            }

            async endSession(additionalSessionData = {}) {
                if (!this.isEnabled || !this.sheetId) {
                    console.log('📝 로그 기록이 비활성화되어 있습니다.');
                    return { success: true, message: '로그 기록 비활성화' };
                }

                this.sessionData.totalLearningTime = this.calculateLearningTime();
                this.sessionData.logTime = new Date();
                this.sessionData.additionalData = { ...this.sessionData.additionalData, ...additionalSessionData };

                const logData = this.formatLogData();
                
                try {
                    const result = await this.sendToGoogleSheet(logData);
                    return result;
                } catch (error) {
                    console.error('❌ 로그 저장 실패:', error);
                    return { success: false, error: error.message };
                }
            }

            formatLogData() {
                const totalSeconds = this.sessionData.totalLearningTime;
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = totalSeconds % 60;
                const formattedTime = minutes + '분 ' + seconds + '초';

                return {
                    기능명: this.templateId,
                    학생이름: this.sessionData.studentName,
                    접속시간: this.sessionData.sessionStartTime.toLocaleString('ko-KR'),
                    학습시간: formattedTime,
                    정오답정보: '정답:' + this.sessionData.correctAnswers + ', 오답:' + this.sessionData.wrongAnswers + ', 스킵:' + this.sessionData.skippedAnswers,
                    힌트사용여부: this.sessionData.hintsUsed,
                    부가정보: JSON.stringify(this.sessionData.additionalData),
                    기록시간: this.sessionData.logTime.toLocaleString('ko-KR')
                };
            }

            async sendToGoogleSheet(logData) {
                if (!this.sheetId) {
                    throw new Error('구글 시트 ID가 설정되지 않았습니다.');
                }

                const form = new URLSearchParams();
                form.append('sheetId', this.sheetId);
                form.append('menu', 'learning_log');
                
                Object.entries(logData).forEach(([key, value]) => {
                    form.append(key, value);
                });

                console.log('📤 구글 시트로 로그 전송:', logData);

                await fetch(this.webAppUrl, {
                    method: 'POST',
                    mode: 'no-cors',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: form.toString()
                });

                console.log('✅ 로그 전송 완료');
                return { success: true, message: '로그가 구글 시트에 저장되었습니다.' };
            }
            
            resetSession() {
                this.sessionData = {
                    studentName: '',
                    sessionStartTime: null,
                    totalLearningTime: 0,
                    correctAnswers: 0,
                    wrongAnswers: 0,
                    skippedAnswers: 0,
                    hintsUsed: false,
                    additionalData: {},
                    logTime: null
                };
                console.log('📝 학습 세션이 초기화되었습니다.');
            }
        }
        
        // 학습 로그 시스템 설정
        const learningLogger = new LearningLogger({
            templateId: 'AI진로경로',
            sheetUrl: '${sheetUrl}',
            isEnabled: ${!!sheetUrl}
        });
        
        // 진행바 차트 업데이트
        function updateCareerBars() {
            const data = makeBarData();
            
            // AI Engineer
            const aiScore = data.find(d => d.cluster === "AI Engineer").Total;
            document.getElementById('ai-score').textContent = aiScore + '점';
            document.getElementById('ai-bar').style.width = Math.min(aiScore * 10, 100) + '%';
            
            // Data Scientist  
            const dataScore = data.find(d => d.cluster === "Data Scientist").Total;
            document.getElementById('data-score').textContent = dataScore + '점';
            document.getElementById('data-bar').style.width = Math.min(dataScore * 10, 100) + '%';
            
            // Product Manager
            const pmScore = data.find(d => d.cluster === "Product Manager (Tech)").Total;
            document.getElementById('pm-score').textContent = pmScore + '점';
            document.getElementById('pm-bar').style.width = Math.min(pmScore * 10, 100) + '%';
            
            // UI Designer
            const uiScore = data.find(d => d.cluster === "UI Designer").Total;
            document.getElementById('ui-score').textContent = uiScore + '점';
            document.getElementById('ui-bar').style.width = Math.min(uiScore * 10, 100) + '%';
        }
        
        // 바 데이터 생성
        function makeBarData() {
            const base = { "AI Engineer": 6, "Data Scientist": 5, "Product Manager (Tech)": 4, "UI Designer": 4 };
            
            if (["INTJ", "INTP", "ENTJ", "ENTP"].includes(mbti)) { 
                base["AI Engineer"] += 3; 
                base["Data Scientist"] += 2; 
            }
            if (["ENFP", "ENFJ", "ENTP", "ESTP"].includes(mbti)) { 
                base["Product Manager (Tech)"] += 3; 
            }
            if (["ISFP", "INFP", "ENFP", "ESFP"].includes(mbti)) { 
                base["UI Designer"] += 3; 
            }
            
            const text = selectedActivities.join(" ").toLowerCase();
            if (/(robot|coding|science|robotics)/.test(text)) base["AI Engineer"] += 3;
            if (/(math|data|blog)/.test(text)) base["Data Scientist"] += 2;
            if (/(store|sales|fair)/.test(text)) base["Product Manager (Tech)"] += 2;
            if (/(design|art|youtube|video)/.test(text)) base["UI Designer"] += 3;
            
            return CLUSTERS.map(c => ({ 
                cluster: c, 
                Personality: Math.max(0, Math.round(base[c] * 0.6)), 
                Activities: Math.max(0, base[c] - Math.round(base[c] * 0.6)), 
                Total: base[c] 
            }));
        }
        
        // 모델 답안 생성
        function getModelAnswer(cefr, task) {
            const samples = {
                A1: 'Hello. I want ' + task + '. Thank you.',
                A2: 'Hello, I need to ' + task.toLowerCase() + '. I am free on Tuesday or Thursday. Thank you.',
                B1: 'Hi, I would like to ' + task.toLowerCase() + ' this week. I am available Tuesday 3 pm or Thursday 5 pm.',
                B2: "Dear Team, I'd like to " + task.toLowerCase() + ' Please let me know a convenient time. Thanks in advance.'
            };
            return samples[cefr] || samples.B1;
        }
        
        // 학습 시작
        function startCareerAnalysis() {
            const name = document.getElementById('studentName').value.trim();
            
            if (!name) {
                alert('이름을 입력해주세요.');
                document.getElementById('studentName').focus();
                return;
            }
            
            studentName = name;
            learningLogger.startSession(studentName, {
                type: 'AI진로경로분석',
                startedAt: new Date().toISOString()
            });
            
            document.getElementById('nameInputSection').style.display = 'none';
            goToStep(1);
        }
        
        // 단계 이동
        function goToStep(step) {
            // 모든 단계 숨기기
            document.getElementById('step1').style.display = 'none';
            document.getElementById('step2').style.display = 'none';
            document.getElementById('step3').style.display = 'none';
            
            // 현재 단계 표시
            if (step === 1) {
                document.getElementById('step1').style.display = 'block';
                // 진행바 차트 초기화
                setTimeout(updateCareerBars, 100);
            } else if (step === 2) {
                document.getElementById('step2').style.display = 'block';
            } else if (step === 3) {
                document.getElementById('step3').style.display = 'block';
                updateTaskDisplay();
            }
            
            currentStep = step;
        }
        
        // CEFR 설정
        function setCefr(level) {
            cefr = level;
            document.querySelectorAll('#cefrButtons button').forEach(btn => {
                btn.className = 'px-3 py-1 rounded-full border bg-white text-slate-800';
            });
            document.querySelector('[data-level="' + level + '"]').className = 'px-3 py-1 rounded-full border bg-purple-600 text-white';
            updateTaskDisplay();
        }
        
        // 활동 토글
        function toggleActivity(activity) {
            const index = selectedActivities.indexOf(activity);
            if (index > -1) {
                selectedActivities.splice(index, 1);
            } else {
                selectedActivities.push(activity);
            }
            
            document.querySelectorAll('#activitiesGrid button').forEach(btn => {
                const text = btn.textContent;
                if (selectedActivities.includes(text)) {
                    btn.className = 'px-2 py-1 rounded-lg text-sm bg-purple-600 text-white';
                } else {
                    btn.className = 'px-2 py-1 rounded-lg text-sm bg-white border';
                }
            });
            
            // 진행바 업데이트
            updateCareerBars();
        }
        
        // MBTI 변경시 진행바 업데이트
        function updateMbtiChart() {
            mbti = document.getElementById('mbtiSelect').value;
            updateCareerBars();
        }
        
        // 경로 생성
        function generatePath() {
            mbti = document.getElementById('mbtiSelect').value;
            const data = makeBarData();
            const sorted = data.slice().sort((a, b) => b.Total - a.Total);
            
            const pathsList = document.getElementById('recommendedPaths');
            pathsList.innerHTML = '';
            sorted.forEach((item, index) => {
                const li = document.createElement('li');
                li.innerHTML = '<span class="text-purple-700 font-bold">' + (index + 1) + '.</span> ' + item.cluster;
                pathsList.appendChild(li);
            });
            
            goToStep(2);
        }
        
        // 작업 표시 업데이트
        function updateTaskDisplay() {
            const currentTask = TASKS[taskIndex % TASKS.length];
            document.getElementById('currentTask').textContent = currentTask;
            document.getElementById('cefrLevel').textContent = cefr;
            document.getElementById('modelAnswer').textContent = getModelAnswer(cefr, currentTask);
        }
        
        // 다음 작업
        function nextTask() {
            taskIndex = (taskIndex + 1) % TASKS.length;
            updateTaskDisplay();
        }
        
        // 텍스트 입력 시 피드백 표시
        document.addEventListener('DOMContentLoaded', function() {
            const textArea = document.getElementById('studentText');
            if (textArea) {
                textArea.addEventListener('input', function() {
                    if (this.value.trim().length > 10) {
                        document.getElementById('feedbackGrid').style.display = 'grid';
                    } else {
                        document.getElementById('feedbackGrid').style.display = 'none';
                    }
                });
            }
            
            // MBTI 변경 시 차트 업데이트
            const mbtiSelect = document.getElementById('mbtiSelect');
            if (mbtiSelect) {
                mbtiSelect.addEventListener('change', updateMbtiChart);
            }
        });
        
        // 학습 완료
        function completeAnalysis() {
            // 요약 정보 업데이트
            document.getElementById('summary-mbti').textContent = mbti;
            document.getElementById('summary-cefr').textContent = cefr;
            document.getElementById('summary-activities').textContent = selectedActivities.join(', ');
            document.getElementById('summary-steps').textContent = currentStep;
            
            // 학습 완료 섹션 표시
            document.getElementById('deploySection').style.display = 'block';
            document.getElementById('deploySection').scrollIntoView({ behavior: 'smooth' });
            
            // 로그 기록
            learningLogger.endSession({
                mbti: mbti,
                cefr: cefr,
                selectedActivities: selectedActivities.join(', '),
                completedSteps: currentStep,
                finalAction: '학습 완료'
            });
            
            console.log('🎉 학습이 성공적으로 완료되었습니다!');
        }
        
        // 퀴즈 리셋 (처음 화면으로 돌아가기)
        function resetQuiz() {
            if (confirm('🔄 처음부터 다시 시작하시겠습니까?')) {
                // 모든 설정 초기화
                mbti = 'INTP';
                cefr = 'B2';
                selectedActivities = ['Art/design'];
                taskIndex = 0;
                currentStep = 0;
                studentName = '';
                
                // UI 초기화
                document.getElementById('step1').style.display = 'none';
                document.getElementById('step2').style.display = 'none';
                document.getElementById('step3').style.display = 'none';
                document.getElementById('deploySection').style.display = 'none';
                document.getElementById('nameInputSection').style.display = 'block';
                
                // 폼 필드 초기화
                document.getElementById('studentName').value = '';
                document.getElementById('mbtiSelect').value = 'INTP';
                
                // CEFR 버튼 초기화
                document.querySelectorAll('#cefrButtons button').forEach(btn => {
                    btn.className = 'px-3 py-1 rounded-full border bg-white text-slate-800';
                });
                document.querySelector('[data-level="B2"]').className = 'px-3 py-1 rounded-full border bg-purple-600 text-white';
                
                // 활동 버튼 초기화
                document.querySelectorAll('#activitiesGrid button').forEach(btn => {
                    const text = btn.textContent;
                    if (text === 'Art/design') {
                        btn.className = 'px-2 py-1 rounded-lg text-sm bg-purple-600 text-white';
                    } else {
                        btn.className = 'px-2 py-1 rounded-lg text-sm bg-white border';
                    }
                });
                
                // 글쓰기 영역 초기화
                document.getElementById('studentText').value = '';
                document.getElementById('feedbackGrid').style.display = 'none';
                
                // 학습 로그 초기화
                learningLogger.resetSession();
                
                // 맨 위로 스크롤
                window.scrollTo({ top: 0, behavior: 'smooth' });
                
                console.log('✅ 진로 분석이 초기화되었습니다.');
            }
        }
        
        // 창 닫기 (HTML 버전에서만 유용)
        function closeWindow() {
            if (confirm('🚪 정말로 창을 닫으시겠습니까?')) {
                // 로그 기록 후 창 닫기
                learningLogger.endSession({
                    mbti: mbti,
                    cefr: cefr,
                    selectedActivities: selectedActivities.join(', '),
                    completedSteps: currentStep,
                    finalAction: '창 닫기'
                });
                
                // 잠시 후 창 닫기 (로그 전송 시간 확보)
                setTimeout(() => {
                    window.close();
                }, 500);
            }
        }
        
        // Enter 키 이벤트
        document.addEventListener('keydown', function(e) {
            if (e.target.id === 'studentName' && e.key === 'Enter') {
                e.preventDefault();
                startCareerAnalysis();
            }
        });
    </script>
</body>
</html>`;
};